<template>
  <div>
    <div v-if="isroot" class="flex justify-between items-center w-100">
      <span class="flex items-center">
        <h3 class="f3 mv3 dib" data-v-step="0">{{task.text}}</h3>
        <i @click="viewStats" data-tooltip="View Statistics" class="dib tooltip ph3 fa fa-lg fa-bar-chart" aria-hidden="true"></i>
      </span>
      <span>
        <i v-if="theme != 'dark'" class="fa fa-lg fa-moon-o" @click="toggleTheme" aria-hidden="true"></i>
        <i v-else class="fa fa-lg fa-sun-o" @click="toggleTheme" aria-hidden="true"></i>
        <i class="fa fa-lg fa-question-circle ml3" @click="$tours['tour'].start()" aria-hidden="true"></i>
      </span>
    </div>
    <div v-else>
      <div id="task-content" class="flex items-center">
        <p v-if="filteredIn">
          <span class="ph2 pv1 pointer handle bg-nord4 br-pill mr2">
            <!-- <i class="fa fa&#45;bars" aria&#45;hidden="true"></i> -->
            {{time}}
          </span>
        </p>
        <div v-if="filteredIn" class="w-100">
          <input 
            @keyup.enter="tryInsert" 
            @keydown.up.prevent="$emit('up', index)" 
            @keydown.down.prevent="tryDown" 
            @keydown.tab.prevent="handleTab" 
            ref="input" 
            spellcheck="false"
            class="bn bg-nord6 nord0 pa0 ma0 w-100 h1" 
            v-show="isEditing" 
            @blur="isEditing = false"
            v-model="task.text" type="text">
          <p class="ma0 w-100 pa0 h1" @click="focus()" v-show="!isEditing" v-html="html"></p>
        </div>
      </div>
      <ActionMenu v-show="isEditing" :task="task"/>
    </div>
    <draggable handle=".handle" dragClass="dragClass" ghostClass="dragArea" :list="task.children" :group="{ name: 'all' }">
      <Task 
        :class="{ml5: !isroot}" 
        v-for="(item, i) in task.children" 
        @insert="insert" 
        @up="up"
        @down="down"
        @indent="indent"
        @dedent="dedent"
        @removeParent="removeParent"
        @dedentParent="dedentParent"
        ref="children"
        v-model="task.children[i]" :key="item.id" :index="i"/>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import Task from "../model/Task.js"
import {msToTime} from "../util/format.js"
function findChild(task, i){
  for(var child of task.$refs.children){
    if(child.index == i) {
      return child
    }
  }
}
export default {
  data: function(){
    return {
      isEditing: false,
      dumb: 0,
      theme: '',
    }
  },
  components: {
    draggable
  },
  methods: {
    tryInsert(){
      if(this.task.children.length == 0){
        this.$emit('insert', this.index)
      } else {
        this.task.children.unshift(new Task())
      }
    },
    track(){
      this.$root.$emit('track', this.task)
    },
    focus(){
      this.isEditing = true
      this.$nextTick(() => this.$refs.input.focus())
    },
    handleTab(event){
      if(event.shiftKey){
        this.$emit('dedent', this.index)
      } else {
        this.$emit('indent', this.index)
      }
    },
    dedentParent(i, j){ //i is grandchild, j is child
      var added = this.task.children[j].children.splice(i)
      var cp = added.shift()
      cp.children = cp.children.concat(added)
      this.task.children.splice(j + 1, 0, cp)
    },
    dedent(i){
      this.$emit('dedentParent', i, this.index)
    },
    insert(i){
      if(this.task.children[i].text == "") return
      this.task.children.splice(i+1, 0, new Task())
    },
    tryDown(){
      if(this.task.children.length > 0) findChild(this, 0).focus()
      else this.$emit('down', this.index)
    },
    down(i){
      if(i < this.task.children.length - 1) {
        findChild(this, i+1).focus()
      }
      else this.$emit("down", this.index)
    },
    up(i){
      if(i == 0){
        this.focus()
      } else {
        var child = this.task.children[i-1]
        var childRef = findChild(this, i-1)
        while(child.children.length != 0){
          childRef = findChild(childRef, child.children.length - 1)
          child = child.children[child.children.length - 1]
        }
        childRef.focus()
      }
    },
    indent(i){
      if(i-1 < 0) return
      this.task.children[i-1].children.push(this.task.children[i])
      this.task.children.splice(i, 1)
    },
    removeParent(i){
      this.task.children.splice(i, 1)
      if(this.isroot && this.task.children.length == 0){
        this.task.children.push(new Task(""))
      }
    },
    remove(){
      this.$emit('removeParent', this.index)
      this.$root.$emit('removeTracking', this.task.id)
    },
    viewStats(){
      this.$router.push({path: `stats/${this.task.id}`})
    },
    toggleTheme(){
      this.theme = this.theme == '' ? "dark" : ''
      document.documentElement.setAttribute('data-theme', this.theme)
      localStorage.setItem('theme', this.theme)
    }
  },
  created(){
    this.$root.$off(this.task.id.toString())
    this.$root.$on(this.task.id.toString(), (seconds, day = new Date()) => {
      this.dumb++
      this.task.addTime(seconds, day)
      this.$emit('input', this.task)
    })
  },
  mounted() {
    this.theme = localStorage.theme
    document.documentElement.setAttribute('data-theme', this.theme)
    if(!this.isroot) this.focus()
    var a = this.task;
    this.task = a;
  },
  computed: {
    task: {
      get () { return this.value },
      set (value) { this.$emit('input', value) },
    },
    html(){
      return this.task.text.replaceAll(/#\w+/gm, "<span class='bg-nord4 pa1 br2 b mh1' href='$&'>$&</span>")
    },
    time(){
      this.dumb;
      return msToTime(this.task.time(false) * 1000)
    },
    filteredIn(){
      return this.$root.tag.length == 0 || this.task.getTags(false).has(this.$root.tag)
    }
  },
  props: {
    index: Number,
    value: Object,
    isroot: Boolean
  }
}
</script>
<style>
input:focus {
  outline: 0;
  padding-top: 3px;
}
.dragClass {
  text: var(--nord0);
  background-color: var(--nord5);
}
.dragArea {
  outline: solid #81A1C1;
  background-color: var(--nord6);
}
</style>
